import { useEffect } from 'react';
import { useAppStore } from '../context/AppContext';
import { AppsMenuHtml } from '../types/ViewModel/AppsMenuHtml';
import useApi from './useApi';
import useApiEndpoints from '../context/useApiEndpoints';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { state, getApiData } = useApi();
    const { setAppsMenu } = useAppStore();
    const { processApiEndpointError } = apiEndpointUtils();

    const getAppsMenuHtml = () => {
        getApiData({
            endpoint: apiEndpoints['getAppsDataHtml'].url,
        });
    };

    useEffect(() => {
        if (state.status === 'success') {
            const appsMenuHtml = state.result as AppsMenuHtml;
            if (appsMenuHtml) {
                setAppsMenu(appsMenuHtml);
            }
        } else {
            processApiEndpointError(state);
        }
    }, [state]);

    return { state, getAppsMenuHtml };
};
